import React from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { percentageFormat } from '@/pages/opinion/utils/value';
import './index.scss';

export default function PercentageItem({
  percentage,
  className,
  formateFunc,
  children = (element: JSX.Element) => element,
  showIcon = true,
}: {
  percentage: number;
  className?: string;
  formateFunc?: (value: any) => string | number;
  children?: (element: JSX.Element) => JSX.Element;
  showIcon?: boolean;
}) {
  let status = '';
  let iconType = '';
  if (percentage > 0 || percentage < 0) {
    iconType = percentage > 0 ? 'green-up-new' : 'red-down-new';
    status = percentage > 0 ? 'success' : 'error';
  }

  return (
    <span className="percentage-item-wrapper">
      {children(
        <span className="percentage-text">
          <span className={` ${className} ${status}`}>
            {formateFunc
              ? formateFunc(percentage)
              : percentageFormat(percentage)}
          </span>
          {percentage !== 0 && showIcon && (
            <SvgIcon type={iconType} className="percentage-icon" />
          )}
        </span>,
      )}
    </span>
  );
}
